<template>
  <section class="shadow-xl rounded-lg bg-white">
    <div class="md:mt-0 mt-3 p-4">
      <div class="flex items-center justify-between">
        <h3 class="mb-2 font-semibold md:text-2xl text-lg">Sales</h3>
        <select
          class="bg-transparent text-xs px-4 py-2 ring-1 ring-gray-400 rounded-lg focus:outline-none"
          v-model="historyType"
        >
          <option value="all">Sessions</option>
          <option value="tips">Tips</option>
        </select>
      </div>
      <!-- <date-range-picker
        ref="picker"
        :auto-apply="true"
        :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
        v-model="dateRange"
      >
        <template v-slot:input="picker">
          {{ picker.startDate }}
          -
          {{ picker.endDate }}
        </template>
      </date-range-picker> -->
      <section class="overflow-x-auto">
        <div class="mb-4">
          <table
            class="mt-6 border-collapse rounded-lg w-full text-left table-auto"
            v-if="historyType === 'all' && trainerOrderList && trainerOrderList.data && trainerOrderList.data.length"
          >
            <thead>
              <tr class="text-lg font-medium border-b-2 border-gray-250">
                <th>Name</th>
                <th>Class Title</th>
                <th>Price</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody >
              <!-- v-if="
                  new Date(list.created_at).getTime() >=
                    dateRange.startDate.getTime() &&
                  new Date(list.created_at).getTime() <=
                    dateRange.endDate.getTime()
                " -->
              <tr v-for="(list, index) in trainerOrderList.data" :key="index">
                <td class="capitalize">{{ list.attendee_name }}</td>
                <td>{{ list.session_title }} {{ list.course_title }}</td>
                <td>{{ intToFloat(list.total_amount, 2) }}</td>
                <td>{{ dateFormat(list.created_at) }}</td>
                <td>
                  <button
                    @click="downloadInvoice(list.order_id, list.attendee_name)"
                    class="havor:shadow-lg focus:outline-none pt-2"
                  >
                    <img
                      :src="require(`@/assets/img/download.webp`)"
                      alt="Cross icon"
                      class="rounded-lg w-6 h-6"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            class="mt-6 border-collapse rounded-lg w-full text-left table-auto"
            v-else-if="trainerTipTransactionList && trainerTipTransactionList.data && trainerTipTransactionList.data.length">
            <thead>
              <tr class="text-lg font-medium">
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">S.No</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Trainer</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Session</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Amount</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Date</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Invoice</th>
                <th class="px-2 py-4 text-left text-sm font-medium text-gray-dark uppercase tracking-wider bg-smokeWhite">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, i) in trainerTipTransactionList.data" :key="i">
                <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize">{{ i + 1 }}</td>
                <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize">{{ data.attendee_name }}</td>
                <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize">{{ data.title }}</td>
                <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize">{{ intToFloat(data.total_amount, 2) }}</td>
                <td class="px-2 py-4 whitespace-nowrap text-sm text-gray-dark capitalize">{{ dateFormat(data.created_at) }}</td>
                <td>
                  <button
                    @click="
                      downloadTipTransactionInvoice(
                        data.order_id,
                        data.attendee_name
                      )
                    "
                    class="havor:shadow-lg focus:outline-none pt-2"
                  >
                    <img
                      :src="require(`@/assets/img/download.webp`)"
                      alt="Cross icon"
                      class="rounded-lg w-6 h-6"
                    />
                  </button>
                </td>
                <td class="capitalize">{{ data.transaction_status }}</td>
              </tr>
            </tbody>
          </table>
          <p v-else>No data found</p>
          <Pagination
            :currentPage="currentPage"
            :handlePageChange="handlePageChange"
            :totalPages="totalPages"
          />
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Pagination } from "@/components/t-components";
export default {
  name: "TrainerProfileSales",
  data() {
    return {
      historyType: "all",
      currentPage: 1,
      totalPages: 1
    };
  },
  components: {
    Pagination
  }, 
  props: [
    'callerComp'
  ],
  computed: {
    ...mapGetters(["trainerOrderList", "trainerTipTransactionList"]),
    isAdminView () {
      return this.callerComp && this.callerComp.length && this.callerComp === 'adminProfileViewer'
    },
    roleId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions([
      "postTrainerOrderList",
      "getTrainerOrderInvoice",
      "postTrainerTipTransactionList",
      "getTrainerTipTransactionInvoice",
    ]),

    async downloadInvoice(id, label) {
      // axios
      //   .get(url, { responseType: "blob" })
      //   .then((response) => {
      //     const blob = new Blob([response.data], { type: "application/pdf" });
      //     const link = document.createElement("a");
      //     link.href = URL.createObjectURL(blob);
      //     link.download = `${label}.pdf`;
      //     link.click();
      //     URL.revokeObjectURL(link.href);
      //   })
      await this.isAdminView && this.roleId ? this.$store.dispatch('getAdminTrainerOrderInvoice', { id: id, label: label, trainerId: this.roleId }) : this.getTrainerOrderInvoice({ id: id, label: label })
    },

    async downloadTipTransactionInvoice(id, label) {
      await this.isAdminView && this.roleId ? this.$store.dispatch('getAdminTrainerTipInvoice', { id: id, label: label, trainerId: this.roleId }) : this.getTrainerTipTransactionInvoice({ id: id, label: label });
    },
    handlePageChange (page) {
      let payload = {
        data: {
          page: page
        }
      }
      this.isAdminView && this.roleId ? payload.userId = this.roleId : ''
      this.historyType && this.historyType === 'all' ? this.trainerSalesHandler(payload) : this.trainerTipsHandler(payload)
    },
    async trainerSalesHandler (payload) {
      await this.$store.dispatch(this.isAdminView ? 'postAdminTrainerOrderList' : 'postTrainerOrderList', payload).then(() => {
        this.currentPage = this.trainerOrderList && this.trainerOrderList.current_page
        this.totalPages = this.trainerOrderList && this.trainerOrderList.last_page
      })
    },
    async trainerTipsHandler (payload) {
      await this.$store.dispatch(this.isAdminView ? 'postAdminTrainerTipTransactionList' : 'postTrainerTipTransactionList', payload).then(() => {
        this.currentPage = this.trainerTipTransactionList && this.trainerTipTransactionList.current_page
        this.totalPages = this.trainerTipTransactionList && this.trainerTipTransactionList.last_page
      })
    }
  },
  watch: {
    historyType (val) {
      let payload = {
        data: {
          page: 1
        }
      }
      this.isAdminView && this.roleId ? payload.userId = this.roleId : ''
      val && val === 'all' ? this.trainerSalesHandler(payload) : this.trainerTipsHandler(payload)
    }
  },
  async created() {
    const payload = {
      data: {
        page: this.currentPage
      }
    }
    this.isAdminView && this.roleId ? payload.userId = this.roleId : ''
    await this.trainerSalesHandler(payload)
    // await this.postTrainerTipTransactionList({ query });
  },
};
</script>
<style scoped lang="scss">
  table{
    tr:nth-child(even) {background-color: #f2f2f2;}
  }
</style>